export const mockUserData = [
  {
    created_at: '2024-01-01T00:00:00Z',
    number: '1-15178099958',
    status: 'open',
    subject: 'Reclamação',
    id: '1-15178099958',
    isOpened: true,
  },
  {
    created_at: '2024-01-01T00:00:00Z',
    number: '1-15178099959',
    status: 'closed',
    subject: 'Elogio',
    id: '1-15178099959',
    isOpened: true,
  },
  {
    created_at: '2024-01-02T00:00:00Z',
    number: '1-15178099967',
    status: 'solved',
    subject: 'Elogio',
    id: '1-15178099967',
    isOpened: true,
  },
  {
    created_at: '2024-01-02T00:00:00Z',
    number: '1-15178099977',
    status: 'pending',
    subject: 'Elogio',
    id: '1-15178099977',
    isOpened: true,
  },
  {
    created_at: '2024-01-02T00:00:00Z',
    number: '1-15178099987',
    status: 'open',
    subject: 'Pergunta',
    id: '1-15178099987',
    isOpened: true,
  },
  {
    created_at: '2024-01-05T00:00:00Z',
    number: '1-15178099997',
    status: 'open',
    subject: 'Pergunta',
    id: '1-15178099997',
    isOpened: true,
  },
  {
    created_at: '2024-01-04T00:00:00Z',
    number: '1-15178099917',
    status: 'new',
    subject: 'Pergunta',
    id: '1-15178099917',
    isOpened: true,
  },
];
